import { type AmountType } from '@alfa-bank/newclick-types';

import { formatAmount } from '@alfalab/utils';

export const getFormatedAmount = (amount: AmountType) => {
    const { formattedWithCurrency } = formatAmount({
        value: amount.value ?? 0,
        minority: amount.minorUnits,
        currency: amount.currency,
        view: 'default',
    });

    return formattedWithCurrency.replace(/[\u2009\u205f]/g, '\u00A0');
};
